module.exports = __webpack_public_path__ + "assets/close-icon-white-background-094821.svg";